import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface OrderNotificationSettings {
  /** Role IDs that should receive order notifications (configured by Super Admin) */
  enabledRoleIds: number[];
  /** Per-user sound toggle, keyed by roleID (persisted across sessions) */
  soundEnabledByUser: Record<string, boolean>;
  /** Duration in seconds for auto-close of toast (5-10) */
  toastAutoCloseSec: number;
}

const initialState: OrderNotificationSettings = {
  // Default: enable notifications for Super Admin (1), Store Admin (2), Store User (3), Fleet Manager (4)
  enabledRoleIds: [1, 2, 3, 4],
  soundEnabledByUser: {},
  toastAutoCloseSec: 8,
};

const orderNotificationSettingsSlice = createSlice({
  name: 'orderNotificationSettings',
  initialState,
  reducers: {
    setEnabledRoleIds(state, action: PayloadAction<number[]>) {
      state.enabledRoleIds = action.payload;
    },
    toggleRoleNotification(state, action: PayloadAction<{ roleId: number; enabled: boolean }>) {
      const { roleId, enabled } = action.payload;
      if (enabled && !state.enabledRoleIds.includes(roleId)) {
        state.enabledRoleIds.push(roleId);
      } else if (!enabled) {
        state.enabledRoleIds = state.enabledRoleIds.filter(id => id !== roleId);
      }
    },
    setSoundEnabled(state, action: PayloadAction<{ userKey: string; enabled: boolean }>) {
      state.soundEnabledByUser[action.payload.userKey] = action.payload.enabled;
    },
    setToastAutoCloseSec(state, action: PayloadAction<number>) {
      state.toastAutoCloseSec = Math.max(3, Math.min(15, action.payload));
    },
  },
});

export const {
  setEnabledRoleIds,
  toggleRoleNotification,
  setSoundEnabled,
  setToastAutoCloseSec,
} = orderNotificationSettingsSlice.actions;

export default orderNotificationSettingsSlice.reducer;
